<top-banner variant="title" [title]="trainingCourse?.course.trainingName"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <ng-container *ngFor="let section of trainingCourse?.course.sections">
        <div class="card">
          <div class="card-body mb-2 d-flex align-items-center training-section-card">
            <span style="flex: 1" *ngIf="section.sectionStatus === TrainingCourseSectionStateType.Completed"><i class="fas fa-check-circle success"></i></span>
            <span style="flex: 1" *ngIf="section.sectionStatus !== TrainingCourseSectionStateType.Completed"><i class="fas fa-times-circle danger"></i></span>

            <span style="flex: 1" *ngIf="section.sectionType === TrainingSectionType.Video"><i class="fa fa-video"></i></span>
            <span style="flex: 1" *ngIf="section.sectionType === TrainingSectionType.Pdf"><i class="fa fa-file-pdf"></i></span>
            <span style="flex: 1" *ngIf="section.sectionType === TrainingSectionType.Question"><i class="fa fa-tasks"></i></span>

            <div style="flex: 10">Section {{section.sectionOrder}}: {{ section.sectionName }}</div>

            <div style="flex: 1" *ngIf="section.sectionStatus === TrainingCourseSectionStateType.Completed">
              <a [routerLink]="['/', routeRole, sectionLink, workerUserCourseId, 'section', section.courseSectionId]" [queryParams]="{type: userCourseType, view: 'review'}">view again</a>
            </div>
            <ng-container *ngIf="nextSection">
              <div style="flex: 1" *ngIf="section.sectionOrder == nextSection.sectionOrder">
                <a class="btn btn-success btn-round" [routerLink]="['/', routeRole, sectionLink, workerUserCourseId, 'section', section.courseSectionId]" [queryParams]="{type: userCourseType}">start</a>
              </div>
              <div style="flex: 1" *ngIf="section.sectionStatus !== TrainingCourseSectionStateType.Completed && section.sectionOrder != nextSection.sectionOrder">
                <!-- empty div -->
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <a [routerLink]="['/', routeRole, 'training']" class="secondary-link-btn">All Courses</a>
    </div>

  </div>
</div>
